import React, {useContext, useState, useRef} from 'react';
import styled from "styled-components";
import { Header, Icon } from '@zebra-fed/zds-react-desktop';
import { AuthContext } from '../authentication/Auth';
import app from '../authentication/firebaseStart';
import '@zebra-fed/icons/General/index.css';
import firebaseUtil from '../data/FirebaseUtil';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from "@material-ui/core/CircularProgress";
import {useTranslation} from "react-i18next";
import AlertModal from "./modals/AlertModal";
import { StyledZebraIcon } from '../styled-components/icons';
import CompatibilityNotificationModal from '../components/modals/CompatibilityNotificationModal';
import {SSOSettingsContext} from '../authentication/SSOSettings';
import UserInfoModal from "../components/modals/UserInfoModal";
import { logoutSSOUser } from '../Services/userService';
import {SSO_CONSTANTS} from '../data/constants'
import { SISENSE_LOGOUT_URL } from '../data/application.properties';
import { useDGAMLicenseCheck } from '../authentication/licensing';


const CustomStyledZebraIcon = styled(StyledZebraIcon)`
  fill: #ffffff;
  height: 50px;
  @media screen and (max-width: 750px) {
    margin-left: 0px;
  }
`;

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  display: ${props => props.disappear ? `flex` : `none`};
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: white;
  font-size: 30px;
`;

const DividerTwo = styled.div`
   opacity: 30%;
   border-left: 1.13px solid #F5F5F5;
   height: 48px;
   margin: 10px 30px 10px 20px;
`;
const DividerThree = styled.div`
   opacity: 30%;
   border-left: 1.13px solid #BDBDBD;
   height: 32px;
   margin: 10px 20px 10px 20px;
   @media screen and (max-width: 750px) {
     display: none;
   }
`;

const StyledRightContainer = styled.div`
    margin-left: auto;
    padding: 4px 0px;
    display: flex;
    @media screen and (max-width: 750px) {
      width: 100%;
      justify-content: space-between;
    }
`;

const StyledImpNotice = styled.div`
    padding: 5px 50px;
    display: flex;
    justify-content: center;
    color: #007aba;
  `;

const Styledbutton = styled.button`
    margin-left:5px;
    background: #007ABACC;
    color: #FFFFFF;
    border:none;
    cursor: pointer;
  `;


const UserTooltip = withStyles((theme) => ({
  tooltip: {
    //backgroundColor: theme.palette.info.light,
    color: 'white',
    boxShadow: theme.shadows[1],
    fontSize: 10,
    //maxWidth: 165
  }
}))(Tooltip);

function DashHeader() {
  const [isLoading, setIsLoading] = useState(false);
  const { currentUser } = useContext(AuthContext);
  const tenantId = currentUser.claims.companyID
  let localSSOLogin = JSON.parse(localStorage.getItem("ssoLogin"));
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState('');
  const alertModalRef = useRef();
  const compatibilityNotificationRef = useRef();
  const { SSOSettings, refreshSSOSettings } = useContext(SSOSettingsContext);
  const [useInfo, setUserInfo] = useState('');
  const defaultBanner = {
    header1:t('compatibilityNotificationContentH1'),
    header2:t('compatibilityNotificationContent3'),
    isEnabled:true
  }
  const [banner,setBanner] = useState(defaultBanner)
  const { isDGAMLicensed } = useDGAMLicenseCheck();
  
  const userInfoModalRef = useRef();
  const firestore = app.firestore();
  const headerStyles = {
    backgroundColor: '#091e42',
    color: '#ffffff',
    boxShadow: '1px 1px 2px 0 rgba(0,0,0,0.25)'
  };

  const iconStyle = {
    cursor: 'pointer',
    display: 'flex',
    margin: '10px 10px 10px 0px',
  }

  const handlePopup = () => {
    compatibilityNotificationRef.current.open()
  }

  React.useEffect(()=>{
    if(localSSOLogin){
      firebaseUtil.getSSOUserInfo().then(res => {
        console.log("SSO detail log user info success",res)
        setUserInfo(res)
        userInfoModalRef.current.open()
      }).catch(error => {
        console.log("SSO detail log user info error:", error.response);
        let errorMsg = error.response && error.response.data ? error.response.data  : "Error in fetching user info"
        setUserInfo(errorMsg)
        userInfoModalRef.current.open()
      });
    }
    getBannerConfig();

  },[])


  /**
   * get banner cconfiguration show default as true if not document exist otherwise 
   * populate with firestore data 
   */
  const getBannerConfig = async ()=>{
      try{
        const doc = await firestore
        .collection("tenants")
        .doc(tenantId)
        .collection('Configuration')
        .doc('Banner')
        .get();

        if(!doc.exists){
          setBanner(defaultBanner)
        }else{
          let config = doc.data()
          setBanner({
            header1:config.header1,
            header2:config.header2,
            isEnabled:config.isEnabled
          })

        } 
      }catch(err){
        setBanner(defaultBanner)
      }
      

      
  }

  const silentLogout = () => {
    var iframe = document.createElement('iframe')
    iframe.setAttribute('nonce', window.NONCE_ID)
    iframe.classList.add('d-none')
    iframe.src = SISENSE_LOGOUT_URL // Load the login page
    document.body.append(iframe)
    // Wait until page is loaded
    iframe.onload = function () {
      // Page is loaded, now remove the iframe
      document.body.removeChild(iframe)
    }
  }

  return (
    <>
    <UserInfoModal
      modalRef={userInfoModalRef}
      message={useInfo}
      onHandleCancel={
        () => {
          setUserInfo(null);
          userInfoModalRef.current.close()
        }}
    />
    <CompatibilityNotificationModal modalRef={compatibilityNotificationRef} />
      <AlertModal modalRef={alertModalRef} message={errorMessage} />
      <Header
        style={headerStyles}
        leftIcon={(
          <img src="/Banner_Zebra_Icon.png" style={{ fill: '#ffffff', height: '50px' }} />
        )}
      >
        <DarkBackground disappear={isLoading}>
          <CircularProgress color="primary" />
          <div>Logout in-progress</div>
        </DarkBackground>
        <DividerTwo />
        <h2>{!isDGAMLicensed ? t('deviceGuardianTitle') : t('deviceGuardianAccessManagement')}</h2>
        <StyledRightContainer>
          {
            // SSOSettings.ssoLogin?
            localSSOLogin ?
              (<>
                <UserTooltip title={
                  <React.Fragment>
                    <Typography color="inherit" style={{ fontSize: 12 }}><b>{'User ID:'}</b> {currentUser.uid}{' '}</Typography>
                    <Typography color="inherit" style={{ fontSize: 12 }}><b>{'SSO Role:'}</b> {currentUser.claims.ssoRole}{' '}</Typography>
                    <Typography color="inherit" style={{ fontSize: 12 }}><b>{'DTRK Role:'}</b> {currentUser.claims.dtrkRole}</Typography>
                  </React.Fragment>} arrow>
                  <p>{currentUser.uid}</p>
                </UserTooltip>
              </>) :
              (<p>{currentUser.email}</p>)

          }
          <DividerThree />
          {
            // SSOSettings.ssoLogin?
            localSSOLogin ?
              (<Icon
                category={'general'}
                name={'sign-out'}
                color={'white'}
                style={iconStyle}
                onClick={() => {
                  sessionStorage.removeItem("selectedSite");
                  console.log("navigator.onLine ", navigator.onLine)
                  if (navigator.onLine) {
                    setIsLoading(true);
                    logoutSSOUser(SSOSettings).then((res) => {
                      console.log("Successfully logoutSSOUser",res)
                    }).catch((err) => {
                        console.log("Error in logoutSSOUser", err);
                        return err;
                    })
                  } else {
                    setErrorMessage(t('messages.error.err44'));
                    alertModalRef.current.toggleDialog();
                  }
                }}
              />) :
              (<Icon
                category={'general'}
                name={'sign-out'}
                color={'white'}
                style={iconStyle}
                onClick={() => {
                  sessionStorage.removeItem("selectedSite");
                  if (navigator.onLine) {
                    firebaseUtil.revokeTokenAccess(t);
                    app.auth().signOut();
                    window.sessionStorage.clear();
                    silentLogout();
                  } else {
                    setErrorMessage(t('messages.error.err44'));
                    alertModalRef.current.toggleDialog();
                  }
                }}
              />)

          }
        </StyledRightContainer>
      </Header>
      { 
        banner.isEnabled && 
        <StyledImpNotice>
          <b>{banner.header1}: </b>&nbsp;{banner.header2}<Styledbutton onClick={handlePopup}>{t('compatibilityNotificationContentHButton')}</Styledbutton>
        </StyledImpNotice>
      }
      
    </>
  );
}

export default DashHeader;